import React, { useState } from 'react'
import pic from '../assets/img/register-dark.png'
import icon from '../assets/img/favicon.icon'
import { Link } from 'react-router-dom'
import swal from 'sweetalert'
import { useNavigate } from 'react-router-dom'
export default function Register() {
  const regUsr=new RegExp('[a-zA-Z]') 
  const regE=new RegExp( '^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$') 
  
  const navigate=useNavigate();
  const [isChecked,setCheck]=useState(false)
  const[user,setUser]=useState(null);
  const[email,setEmail]=useState(null);
  const[pass,setPass]=useState(null);
  const check=(e)=>{
   setCheck(e.target.checked)
   console.log("ischeck\t"+isChecked);
  }
  // const inpUser=(e)=>{
  //      usr= e.target.value;
  //     // console.log(usr);
      
  // }
  // const inpEmail=(e)=>{
  //      email= e.target.value;
  //     // console.log(email);
      
  // }
  // const inpPass=(e)=>{
  //     pass= e.target.value;
  //     // console.log(pass);
      
  // }
  const register=function () {
    
      if(user!=null && email!=null && pass!=null){
        
        
        if(regUsr.test(user) && regE.test(email) && pass.length>4){
          const newTask = {
            username:user,
            email:email,
            password:pass,
         
          };
          
          fetch('https://66caec954290b1c4f1990ef1.mockapi.io/register', {
            method: 'POST',
            headers: {'content-type':'application/json'},
            // Send your data in the request body as JSON
            body: JSON.stringify(newTask)
          }).then(res => {
            if (res.ok) {
                return res.json();
            }
            // handle error
          }).then(task => {
            swal("ثبت نام انجام شد");
            navigate('/home');
          }).catch(error => {
            swal("ثبت نام انجام نشد");
          })
        
        }
      }
      
        

  }
  return (
    <>
        <section className='w-full h-[100vh] flex-row-reverse flex justify-center items-center *:h-full overflow-x-hidden'>
              <section className='bg-[#283144] flex  justify-center items-center h-full w-full md:w-1/3'>
                    <section className='w-[80%]  h-[80%] flex flex-wrap  justify-center items-center  *:h-1/11 *:w-full '>
                          <div className='flex items-center *:px-1 *:h-full'>
                              <figure>
                                <img className='object-cover w-10 h-10' src={icon} alt="Logo" />
                              </figure>

                              <span className='text-2xl font-semibold text-[#D8DEEA]'>
                                  فرست
                              </span>
                          </div>
                          <div className=''>
                              <h4 className='text-[#D8DEEA]  font-medium h-full'>ماجراجویی اینجا شروع می‌شود</h4>
                          </div>
                          <div className=''>
                            <span className='text-[#a1b0cb]'>مدیریت برنامه خود را آسان و جذاب کنید!</span>
                          </div>
                          <div className='flex flex-wrap *:py-1'>
                              <label className='w-full text-[0.75rem] text-[#546990]' for="">نام کاربری</label>
                              <input onChange={(e)=>{setUser(e.target.value)}} type="text" className="w-full outline-0 bg-transparent focus:border-[#5a8dee] border border-[#546990] h-10 p-2 rounded" placeholder='نام کاربری خود را وارد کنید'/>
                          </div>
                          <div className='flex flex-wrap *:py-1'>
                              <label className='w-full text-[0.75rem] text-[#546990]' for=""> ایمیل</label>
                              <input onChange={(e)=>{setEmail(e.target.value)}}  type="email" className="w-full outline-0 bg-transparent focus:border-[#5a8dee] border border-[#546990] h-10 p-2 rounded" placeholder=' ایمیل خود را وارد کنید'/>
                          </div>
                          <div className='flex flex-wrap *:py-1'>
                              <label className='w-full text-[0.75rem] text-[#546990]' for=""> رمز عبور</label>
                              <input onChange={(e)=>{setPass(e.target.value)}}  type="password" aria-describedby="password" className="w-full text-[#546990] outline-0 bg-transparent focus:border-[#5a8dee] border border-[#546990] h-10 p-2 rounded" placeholder='.........'/>
                          </div>
                         
                          <div className='flex items-center  *:px-1'>
                                <div className='flex items-center   h-full'>
                                <input type='checkbox' checked={isChecked} onChange={check} className='w-fit  bg-transparent focus:border-[#5a8dee] border border-[#546990]  rounded'  required />
                                <span className='h-full flex  font-semibold px-1 text-[#546990]'>من موافقم با</span>
                                <span className='h-full flex  font-semibold text-[#5a8dee]'>سیاست حریم خصوصی و قوانین</span>
                               
                                </div>

                               
                          </div>
                          <div className='flex justify-center items-center'>
                              <button onClick={register} className='w-full h-10 hover:duration-100 hover:shadow-sh bg-[#5a8dee] text-white text-md rounded'>عضویت</button>
                          </div>
                          <div className=''>
                              <span className='font-semibold text-md text-[#546990]'>حساب کاربری دارید؟</span>
                              <Link className='font-semibold text-md text-[#5a8dee]' to="/login">وارد شوید</Link>
                          </div>
                          <div className='flex justify-center items-center '>
                              <span className=' h-1 flex bg-[#2F3B50] w-2/6'></span>
                              <span className='text-[#9992A3] text-center font-bold  w-1/6'>یا</span>
                              <span className=' h-1 flex bg-[#2F3B50] w-2/6'></span>
                          </div>
                          <div className='flex justify-center items-center *:px-4 *:text-3xl'>
                                <div className=''>
                                <span  className='bg-[#2b3751] group rounded hover:bg-white  flex w-10 h-10 justify-center items-center'><i class="ri-twitter-x-line  text-black"></i></span>
                                    
                                </div>
                                <div className=''>
                                   <span  className='bg-[#bc40305b] group rounded hover:bg-[#bc4030]  flex w-10 h-10 justify-center items-center'><i class="ri-facebook-fill group-hover:text-white  text-[#dd4b39]"></i></span>
                                   
                                </div>
                                <div className=''>
                                    <span  className='bg-[#264360] group rounded hover:bg-[#1DA1F2]  flex w-10 h-10 justify-center items-center'><i class="ri-instagram-fill group-hover:text-white  text-[#1da1f2]"></i></span>
                                </div>
                          </div>
                    </section>
              
              </section>
              <section className='bg-[#1C222F] h-full hidden md:flex w-2/3 justify-center items-center'>
                  <div className='flex flex-wrap w-full h-full justify-center items-center *:w-full '>
                        <div className='flex justify-center items-center'>
                          <figure className='h-full'>
                            <img className='object-contain w-full h-[550px]' src={pic} alt='image' />
                            
                          </figure>
                        </div>
                        <div className='flex justify-center items-center *:w-full flex-wrap text-center *:py-2 '>
                              <h2 className='text-[#D8DEEA] text-2xl' >چند کلیک تا شروع</h2>
                              <p  className=' text-[#a1b0cb] flex justify-center' > دوره آزمایشی 14 روزه رایگان خود را شروع کرده و<br/>همین امروز ایجاد برنامه خود را شروع کنید.</p>
                       </div>
                  </div>
              </section>
             
        </section> 
    </>
  )
}
